import { ref } from "@vue/composition-api";

export default function () {
    {
        const refreshing = ref<boolean>(false);
        const registration = ref<ServiceWorkerRegistration>();
        const updateExists = ref<boolean>(false);

        // Store the SW registration so we can send it a message
        // We use `updateExists` to control whatever alert, toast, dialog, etc we want to use
        // To alert the user there is an update they need to refresh for
        // Called when the user accepts the update
        const updateAvailable = (event: any) => {
            registration.value = event.detail;
            updateExists.value = true;
        };

        const refreshApp = () => {
            updateExists.value = false;
            if (registration.value && registration.value.waiting) {
                // send message to SW to skip the waiting and activate the new SW
                registration.value.waiting.postMessage({
                    type: "SKIP_WAITING",
                });
            } else {
                // unregister the service worker to clear the cache
                navigator.serviceWorker
                    .getRegistrations()
                    .then((registrations) => {
                        for (const registration of registrations) {
                            registration.unregister();
                        }
                        // reload the page to activate the new SW
                        window.location.reload();
                    });
            }
        };
        // Listen for our custom event from the SW registration
        document.addEventListener("swUpdated", updateAvailable, {
            once: true,
        });
        // Prevent multiple refreshes
        navigator.serviceWorker.addEventListener("controllerchange", () => {
            if (refreshing.value) return;
            refreshing.value = true;
            // Here the actual reload of the page occurs
            window.location.reload();
        });
        return {
            refreshApp,
            updateExists,
        };
    }
}
